import PlayerAvailablePOIsDTO from "../../models/teleport/PlayerAvailablePOIsDTO";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function getMyTeleportingPOIs(client: BackendClient): Promise<PlayerAvailablePOIsDTO> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<PlayerAvailablePOIsDTO>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.GetMyTeleportingPOIs}`, {headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to get my player available pois: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }